import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Standard inner-page closing CTA. Deep-green panel with primary CTA.
 */
export function InnerCTA({ eyebrow = "Ready when you are.", heading, body, ctaLabel = "Book a Free Scoping Call", ctaTo = "/contact", extra }) {
  return (
    <section className="bg-white" data-testid="inner-cta">
      <div className="mx-auto max-w-6xl px-4 pb-20 lg:px-6 lg:pb-28">
        <div className="grain-overlay relative overflow-hidden rounded-2xl bg-wafa-deep p-8 sm:p-12 lg:p-16">
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-sunshine">{eyebrow}</div>
          {heading ? (
            <h2 className="mt-3 max-w-3xl font-heading text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
              {heading}
            </h2>
          ) : null}
          {body ? <p className="mt-4 max-w-2xl text-sm text-white/85 lg:text-base">{body}</p> : null}
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to={ctaTo}
              className="inline-flex items-center gap-2 rounded-md bg-wafa-primary px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-wafa-sunshine hover:text-wafa-deep"
              data-testid="inner-cta-button"
            >
              {ctaLabel} <ArrowRight className="h-4 w-4" />
            </Link>
            {extra}
          </div>
        </div>
      </div>
    </section>
  );
}
